import React from 'react';
import { Space, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { getMediaTypeDisplay } from '../../../../../utils/getMediaTypeDisplay';

const { Text } = Typography;

const QuotedMessagePreview = ({ reply_to_message, isCustomerMessage, onClick, isDarkMode }) => {
    const { t } = useTranslation();
    if (!reply_to_message) return null;

    // Determine what to display: content or media type
    const getDisplayText = () => {
        if (reply_to_message.content) {
            return reply_to_message.content;
        }

        // If no content but has media, show media type with icon
        if (reply_to_message.media && reply_to_message.media.length > 0) {
            const firstMedia = reply_to_message.media[0];
            const { icon, translationKey } = getMediaTypeDisplay(firstMedia.media_type);
            return `${icon} ${t(translationKey)}`;
        }

        // Fallback for messages with neither content nor media
        return '';
    };

    const borderColor = isDarkMode
        ? isCustomerMessage
            ? 'rgba(255, 255, 255, 0.8)'
            : '#FFD700'
        : isCustomerMessage
            ? 'rgba(255, 255, 255, 0.8)'
            : '#1890ff';
    const titleColor = isDarkMode
        ? isCustomerMessage
            ? 'rgba(255, 255, 255, 0.85)'
            : '#FFD700'
        : isCustomerMessage
            ? 'rgba(255, 255, 255, 0.85)'
            : '#1890ff';
    const contentColor = isDarkMode
        ? isCustomerMessage
            ? 'rgba(255, 255, 255, 0.75)'
            : 'rgba(255, 255, 255, 0.65)'
        : isCustomerMessage
            ? 'rgba(255, 255, 255, 0.75)'
            : 'rgba(0, 0, 0, 0.45)';

    return (
        <Space
            direction="vertical"
            size={0}
            style={{
                borderInlineStart: `2px solid ${borderColor}`,
                paddingInlineStart: 4,
                marginBottom: 4,
                cursor: 'pointer',
                maxWidth: '100%',
                overflow: 'hidden'
            }}
            onClick={(e) => {
                e.stopPropagation();
                onClick();
            }}
        >
            <Text strong style={{
                fontSize: '11px',
                color: titleColor
            }}>
                {reply_to_message.sender_type}
            </Text>
            <Text style={{
                fontSize: '11px',
                color: contentColor,
                whiteSpace: 'pre-wrap',
                wordBreak: 'break-word',
                overflowWrap: 'anywhere'
            }}>
                {getDisplayText()}
            </Text>
        </Space>
    );
};

export default QuotedMessagePreview;

